import {callAPI} from 'services/api';

export async function startCardSetup() {
  const result = await callAPI('/payments/start-card-setup/', 'POST', null, true);
  return result.client_secret;
}